import React from "react";

// components
import AlcoholCommonTable from "../../table/AlcoholCommonTable";
import CommonPagination from "../../../pagination/CommonPagination";

// utils
import { hasForbiddenChars, FORBIDDEN_CHARS_MSG } from "../../../../utils/sanitize";

function SearchTablePageLayout({
	type,
	pageInfo,
	tableBody,
	totalCnt,
	setShowRegisterModal,
	setShowDeleteModal,
	setShowModifyModal,
	setModifyTarget,
	setShowSaveModal,
	checkedItems,
	setCheckedItems,
	tablePageCnt,
	selectedPage,
	setSelectedPage,
	getNewTableDataByPagination,
	totalCheck,
	setTotalCheck,
	searchOption,
	setSearchOption,
	resetSearchOption,
	applySearchOption,
	setting,
	setSetting,
	authorityData,
	setAuthorityData,
	modifyAuthorityList,
	setModifyAuthorityList,
	clickEvent,
	selectedOrderOption,
	setSelectedOrderOption
}) {

	function handleCheckInputTraining(selectedTraining) {
		if(searchOption.training){
			const curTrainingList = searchOption.training.split("|");
			if(curTrainingList.includes(selectedTraining)){
				setSearchOption({
					...searchOption,
					training: curTrainingList.filter(e=>e!==selectedTraining).join("|")
				})
			}else{
				setSearchOption({
					...searchOption,
					training: [...curTrainingList,selectedTraining].sort((a,b)=>Number(a)-Number(b)).join("|")
				})
			}		
		}else{
			setSearchOption({
				...searchOption,
				training: selectedTraining
			})
		}		
	}

    return (
        <div className="dashboardContent">
			<div className="dashboardContent__title">
				<span className="dashboardContent__title__content">{pageInfo.title}</span>
			</div>
			<div className="dashboardContent__inner">
				<div className="patientManageList">
                    <div className={`patientManageList__search ${type==="authority" ? "Search-Authority" : ""}`}>
						{type==="authority" && <div className="Authority-Setting-ButtonList">
							<button
								onClick={()=>setSetting("시스템 관리자")}
								disabled={setting==="시스템 관리자"}
							>
								시스템 관리자
							</button>
							<button
								onClick={()=>setSetting("의료진")}
								disabled={setting==="의료진"}
							>
								의료진
							</button>
							<button
								onClick={()=>setSetting("임상 관리자")}
								disabled={setting==="임상 관리자"}
							>
								임상 관리자
							</button>
						</div>}
                        <div className="SearchTablePage-Header">
                            <div className="Header-Title">검색 조건</div>
                            <div className="Header-Button">
                                <button className="White" onClick={resetSearchOption}>초기화</button>
                                <button
                                    className="Blue"
                                    onClick={() => {
                                        if (hasForbiddenChars(searchOption.search)) return;
                                        applySearchOption();
                                    }}
                                >검색</button>
                            </div>
                        </div>
						<div className="SearchWrapper">
							<div className="SearchBar">
								<span className="searchBar__label">검색</span>
								<input
									className="Search-Input"
									type="text"
									maxLength={300}
									placeholder={pageInfo.search.inputPlaceholder}
									onChange={(e)=>setSearchOption({
										...searchOption,
										search: e.target.value
									})}
									value={searchOption.search}
								/>
								{hasForbiddenChars(searchOption.search) && (
									<div className="validation" style={{ color: '#DC3545', marginTop: '0.5rem' }}>
										{FORBIDDEN_CHARS_MSG}
									</div>
								)}
							</div>
							{/* 환자 관리 페이지 검색 조건 */}
							{type==="patient" && (
								<div className="SearchBar">
									<span className="searchBar__label">환자 타입</span>
									<div className="MultipleSearch">
										<div className="Radio-Row">
											<span>문제성 음주</span>
											<div className="Radio-Row-Item">
												<input
													id="problem-high"
													name="problem"
													type="radio"
													onChange={()=>setSearchOption({
														...searchOption,
														patientTypeProblem: "High"
													})}
													checked={searchOption.patientTypeProblem === "High"}
												/>
												<label htmlFor="problem-high">High</label>
											</div>
											<div className="Radio-Row-Item">
												<input
													id="problem-low"
													name="problem"
													type="radio"
													onChange={()=>setSearchOption({
														...searchOption,
														patientTypeProblem: "Low"
													})}
													checked={searchOption.patientTypeProblem === "Low"}
												/>
												<label htmlFor="problem-low">Low</label>
											</div>
										</div>						
										<div className="Radio-Row">
											<span>변화 준비</span>
											<div className="Radio-Row-Item">
												<input
													id="change-ready"
													name="change"
													type="radio"
													onChange={()=>setSearchOption({
														...searchOption,
														patientTypeChange: "Ready"
													})}
													checked={searchOption.patientTypeChange === "Ready"}
												/>
												<label htmlFor="change-ready">Ready</label>
											</div>
											<div className="Radio-Row-Item">
												<input
													id="change-no"
													name="change"
													type="radio"
													onChange={()=>setSearchOption({
														...searchOption,
														patientTypeChange: "No"
													})}
													checked={searchOption.patientTypeChange === "No"}
												/>
												<label htmlFor="change-no">No</label>
											</div>
										</div>
									</div>
								</div>
							)}
							{type==="patient" && (
								<div className="SearchBar">
									<span className="searchBar__label">환자군</span>
									<div className="Radio-Row">
										<div className="Radio-Row-Item">
											<input
												id="patient-group-experimental"
												name="patient-group"
												type="radio"
												onChange={()=>setSearchOption({
													...searchOption,
													patientGroup: "실험군"
												})}
												checked={searchOption.patientGroup === "실험군"}
											/>
											<label htmlFor="patient-group-experimental">실험군</label>
										</div>
										<div className="Radio-Row-Item">
											<input
												id="patient-group-control"
												name="patient-group"
												type="radio"
												onChange={()=>setSearchOption({
													...searchOption,
													patientGroup: "대조군"
												})}
												checked={searchOption.patientGroup === "대조군"}
											/>
											<label htmlFor="patient-group-control">대조군</label>
										</div>
										<div className="Radio-Row-Item">
											<input
												id="patient-group-test"
												name="patient-group"
												type="radio"
												onChange={()=>setSearchOption({
													...searchOption,
													patientGroup: "테스트"
												})}
												checked={searchOption.patientGroup === "테스트"}
											/>
											<label htmlFor="patient-group-test">테스트</label>
										</div>
										<div className="Radio-Row-Item">
											<input
												id="patient-group-general"
												name="patient-group"
												type="radio"
												onChange={()=>setSearchOption({
													...searchOption,
													patientGroup: "일반"
												})}
												checked={searchOption.patientGroup === "일반"}
											/>
											<label htmlFor="patient-group-general">일반</label>
										</div>
									</div>
								</div>
							)}
							{type==="patient" && <div/>}
							{type==="patient" && (
								<div className="SearchBar">
									<span className="searchBar__label">교육</span>
									<div className="Radio-Row">										
										<div className="Radio-Row-Item">
											<input
												id="progress-10"
												name="progress"
												type="radio"
												onChange={()=>setSearchOption({
													...searchOption,
													progress: "시작 전"
												})}
												checked={searchOption.progress === "시작 전"}
											/>
											<label htmlFor="progress-10">시작 전</label>
										</div>
										<div className="Radio-Row-Item">
											<input
												id="progress-20"
												name="progress"
												type="radio"
												onChange={()=>setSearchOption({
													...searchOption,
													progress: "정상"
												})}
												checked={searchOption.progress === "정상"}
											/>
											<label htmlFor="progress-20">정상</label>
										</div>
										<div className="Radio-Row-Item">
											<input
												id="progress-40"
												name="progress"
												type="radio"
												onChange={()=>setSearchOption({
													...searchOption,
													progress: "미달"
												})}
												checked={searchOption.progress === "미달"}
											/>
											<label htmlFor="progress-40">미달</label>
										</div>
										<div className="Radio-Row-Item">
											<input
												id="progress-45"
												name="progress"
												type="radio"
												onChange={()=>setSearchOption({
													...searchOption,
													progress: "탈락"
												})}
												checked={searchOption.progress === "탈락"}
											/>
											<label htmlFor="progress-45">탈락</label>
										</div>
										<div className="Radio-Row-Item">
											<input
												id="progress-30"
												name="progress"
												type="radio"
												onChange={()=>setSearchOption({
													...searchOption,
													progress: "종료"
												})}
												checked={searchOption.progress === "종료"}
											/>
											<label htmlFor="progress-30">종료</label>
										</div>
									</div>
								</div>
							)}			
							{type==="patient" && <div/>}
							{type==="user" && (
								<div className="SearchBar">
									<span className="searchBar__label">권한</span>
									<select
										className="SearchBar-Select"
										value={searchOption.authority}
										onChange={(e)=>setSearchOption({
											...searchOption,
											authority: e.target.value
										})}
									>
										<option value="">전체</option>
										<option value="시스템 관리자">시스템 관리자</option>
										<option value="의료진">의료진</option>
										<option value="임상 관리자">임상 관리자</option>
									</select>
								</div>
							)}
							{/* 단체 메시지 페이지 검색 조건 */}							
							{type==="notification" && <div/>}
							{type==="notification" && (
								<div className="SearchBar">
									<span className="searchBar__label">받는 사람</span>
									<div className="Radio-Row">
										<div className="Radio-Row-Item">
											<input
												id="notification-target-yes"
												name="patient-group"
												type="radio"
												onChange={()=>setSearchOption({
													...searchOption,
													target: pageInfo.convertKorToEng.target["전체 사용자"]
												})}
												checked={searchOption.target === pageInfo.convertKorToEng.target["전체 사용자"]}
											/>
											<label htmlFor="notification-target-yes">전체 사용자</label>
										</div>
										<div className="Radio-Row-Item" />
										<div className="Radio-Row-Item">
											<input
												id="notification-target-no"
												name="patient-group"
												type="radio"
												onChange={()=>setSearchOption({
													...searchOption,
													target: pageInfo.convertKorToEng.target.타겟팅
												})}
												checked={searchOption.target === pageInfo.convertKorToEng.target.타겟팅}
											/>
											<label htmlFor="notification-target-no">타겟팅</label>
										</div>
									</div>
								</div>
							)}
							{type==="notification" && (
								<div className="SearchBar">
									<span className="searchBar__label">교육</span>
									<div className="MultipleSearch">
										<div className="Radio-Row">
											<span> </span>
											<div className="Radio-Row-Item">
												<input
													id="search-training-10"
													name="search-training"
													type="checkbox"
													onChange={()=>handleCheckInputTraining("10")}
													checked={searchOption.training.includes("10")}
													disabled={searchOption.target!==pageInfo.convertKorToEng.target.타겟팅}
												/>
												<label htmlFor="search-training-10">시작 전</label>
											</div>
											<div className="Radio-Row-Item">
												<input
													id="search-training-20"
													name="search-training"
													type="checkbox"
													onChange={()=>handleCheckInputTraining("20")}
													checked={searchOption.training.includes("20")}
													disabled={searchOption.target!==pageInfo.convertKorToEng.target.타겟팅}
												/>
												<label htmlFor="search-training-20">정상</label>
											</div>
										</div>						
										<div className="Radio-Row">
											<span> </span>
											<div className="Radio-Row-Item">
												<input
													id="search-training-40"
													name="search-training"
													type="checkbox"
													onChange={()=>handleCheckInputTraining("40")}
													checked={searchOption.training.includes("40")}
													disabled={searchOption.target!==pageInfo.convertKorToEng.target.타겟팅}
												/>
												<label htmlFor="search-training-40">미달</label>
											</div>
											<div className="Radio-Row-Item">
												<input
													id="search-training-45"
													name="search-training"
													type="checkbox"
													onChange={()=>handleCheckInputTraining("45")}
													checked={searchOption.training.includes("45")}
													disabled={searchOption.target!==pageInfo.convertKorToEng.target.타겟팅}
												/>
												<label htmlFor="search-training-45">탈락</label>
											</div>
											<div className="Radio-Row-Item">
												<input
													id="search-training-30"
													name="search-training"
													type="checkbox"
													onChange={()=>handleCheckInputTraining("30")}
													checked={searchOption.training.includes("30")}
													disabled={searchOption.target!==pageInfo.convertKorToEng.target.타겟팅}
												/>
												<label htmlFor="search-training-30">종료</label>
											</div>
										</div>
									</div>
								</div>
							)}
							{type==="notification" && (
								<div className="SearchBar">
									<span className="searchBar__label">성별</span>
									<div className="Radio-Row">
										<div className="Radio-Row-Item">
											<input
												id="notification-sex-all"
												name="notification-sex"
												type="radio"
												onChange={()=>setSearchOption({
													...searchOption,
													sex: "A"
												})}
												checked={searchOption.sex === "A" || searchOption.target === pageInfo.convertKorToEng.target["전체 사용자"]} // 전체 사용자일 때는 성별 필터링을 하지 않음
												disabled={searchOption.target === pageInfo.convertKorToEng.target["전체 사용자"]} // 전체 사용자일 때는 성별 필터링을 할 수 없음
											/>
											<label htmlFor="notification-sex-all">전체</label>
										</div>
										<div className="Radio-Row-Item">
											<input
												id="notification-sex-man"
												name="notification-sex"
												type="radio"
												onChange={()=>setSearchOption({
													...searchOption,
													sex: "M"
												})}
												checked={searchOption.sex === "M"}
												disabled={searchOption.target === pageInfo.convertKorToEng.target["전체 사용자"]} // 전체 사용자일 때는 성별 필터링을 할 수 없음
											/>
											<label htmlFor="notification-sex-man">남</label>
										</div>
										<div className="Radio-Row-Item">
											<input
												id="notification-sex-female"
												name="notification-sex"
												type="radio"
												onChange={()=>setSearchOption({
													...searchOption,
													sex: "F"
												})}
												checked={searchOption.sex === "F"}
												disabled={searchOption.target === pageInfo.convertKorToEng.target["전체 사용자"]} // 전체 사용자일 때는 성별 필터링을 할 수 없음
											/>
											<label htmlFor="notification-sex-female">여</label>
										</div>
									</div>
								</div>
							)}			
							{type==="notification" && <div/>}
						</div>
					</div>
					<div className="patientManageList__list">
						<div className="SearchTablePage-Header">
                            <div className="Header-Title">{pageInfo.list.title}</div>
							{pageInfo.list.selectOptionList.length>0 &&
								<div className="Header-Select">
									<select value={selectedOrderOption} onChange={(e)=>setSelectedOrderOption(e.target.value)}>
										<option value="" disabled hidden>
											정렬 조건
										</option>
										{pageInfo.list.selectOptionList.map(item => {
											return <option key={item.key} value={item.value}>{item.name}</option>;
										})}
									</select>
									<div className="White-Arrow" />  
								</div>
							}
							<div className="Header-Button">
								{type!=="authority" && (
									<button
										className="Blue"
										onClick={()=>setShowRegisterModal(true)}
									>
										{type==="notification" ? '메시지 보내기' : '신규 추가'}
									</button>								
								)}
								{type!=="authority" && type!=="notification" && (
									<button
										className="Blue"
										onClick={() => {
											if(Object.values(checkedItems).length > 0){
												setShowDeleteModal(true);
											}else if(type==="patient") {											
												alert('환자를 선택해주세요.');
											}else if(type==="institution"){
												alert('기관을 선택해주세요.');											
											}else if(type==="user"){
												alert('사용자를 선택해주세요.');
											}else if(type==="notification"){
												alert('알림을 선택해주세요.');
											}
										}}
									>
										삭제
									</button>
								)}						
								{type==="authority" && (
									<button
										className="Blue"
										onClick={()=>setShowSaveModal(true)}
									>
										저장하기
									</button>
								)}								
							</div>
						</div>
                        <div className="SearchTablePage-Table-Wrapper">
							<div className="SearchTablePage-Table-ItemCnt">총 {totalCnt}{(type==="patient" || type==="user") ? '명' : "개"}</div>
                            <AlcoholCommonTable
								type={type}
                                tableHeader={pageInfo.list.tableHeader}
                                tableBody={tableBody}
								checkedItems={checkedItems}
								setCheckedItems={setCheckedItems}
								totalCheck={totalCheck}
								setTotalCheck={setTotalCheck}
								setShowModifyModal={setShowModifyModal}
								setModifyTarget={setModifyTarget}
								authorityData={authorityData}
								setAuthorityData={setAuthorityData}
								modifyAuthorityList={modifyAuthorityList}
								setModifyAuthorityList={setModifyAuthorityList}
								clickEvent={clickEvent}
                            />
							<CommonPagination
								pageCnt={tablePageCnt}
								selectedPage={selectedPage}
								SetSelectedPage={setSelectedPage}
								GetNewTableData={getNewTableDataByPagination}
							/>
                        </div>
					</div>
				</div>
			</div>
		</div>
    );
}

export default SearchTablePageLayout;